// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clockCog16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clock-cog': IconClockCog;
    }
}

/**
 * The icon component for the 'clockCog' icon
 */
export class IconClockCog extends Icon {
    public constructor() {
        super(clockCog16X16);
    }
}

registerIcon('icon-clock-cog', IconClockCog);
export const iconClockCogTag = 'nimble-icon-clock-cog';
